import { computed, onBeforeUnmount, ref, Ref, watch } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import providers from "@/lib/api";

export default function useConvertingFiles(
  messageList: Ref<Message[]>,
  updateItem: (newItem: Message, comparator: (i1: Message, i2: Message) => boolean) => void
) {
  const checkConvertingStatusTimeoutId = ref<ReturnType<typeof setTimeout> | null>(null);

  const convertingMessages = computed<Message[]>(() => {
    return messageList.value.filter(
      msg =>
        msg.attachment.length > 0 && msg.attachment.some(f => ["NEW", "CONVERTING"].includes(f.file.processingStatus))
    );
  });

  const cleanTimeout = () => {
    checkConvertingStatusTimeoutId.value && clearTimeout(checkConvertingStatusTimeoutId.value);
    checkConvertingStatusTimeoutId.value = null;
  };

  const checkConvertingStatus = () => {
    cleanTimeout();

    checkConvertingStatusTimeoutId.value = setTimeout(async () => {
      const ids = (convertingMessages.value ?? []).map(i => i.id);

      if (ids.length === 0) {
        cleanTimeout();
        return;
      }
      const updatedMessages = await providers.MessagesProvider.find({ data: { ids } });
      updatedMessages.result.forEach(m => updateItem(m, (i1, i2) => i1.id === i2.id));
      checkConvertingStatus();
    }, 3000);
  };

  watch(messageList, () => {
    const ids = (convertingMessages.value ?? []).map(i => i.id);
    if (ids.length > 0 && !checkConvertingStatusTimeoutId.value) {
      checkConvertingStatus();
    }
  });

  onBeforeUnmount(() => {
    cleanTimeout();
  });
}
